export default {
  path: "/app/document-iso",
  name: "document-iso",
  redirect: "/app/document-iso/list-standard",
  component: () => import("./layout"),
  children: [
    //old flow
    {
      path: "list",
      name: "listDocument",
      component: () => import("./components/listDocument/listDocumentPublic"),
      meta: {
        appName: "listDocument",
      },
    },

    {
      path: "list/:departmentId",
      name: "listDocumentPublicDocumentType",
      component: () =>
        import("./components/listDocument/listDocumentPublicDocumentType"),
      meta: {
        appName: "listDocument",
      },
    },
    {
      path: "list/:departmentId/:documentTypeId",
      name: "listDocumentPublicFiltered",
      component: () =>
        import("./components/listDocument/listDocumentPublicFiltered"),
      meta: {
        appName: "listDocument",
      },
    },
    //////////

    ///new flow
    {
      path: "list-standard",
      name: "listDocumentIsoStandard",
      component: () =>
        import("./components/listDocument/listDocumentPublicIsoStandard"),
      meta: {
        appName: "listDocument",
      },
    },

    {
      path: "list-standard/:documentIsoStandardId",
      name: "listDocumentPublicDocumentIsoStandardIssued",
      component: () =>
        import(
          "./components/listDocument/listDocumentPublicDocumentIsoStandardIssued"
        ),
      meta: {
        appName: "listDocument",
      },
    },
    {
      path: "list-standard/:documentIsoStandardId/:departmentId",
      name: "listDocumentPublicDocumentTypeIsoStandard",
      component: () =>
        import(
          "./components/listDocument/listDocumentPublicDocumentTypeIsoStandard"
        ),
      meta: {
        appName: "listDocument",
      },
    },
    {
      path:
        "list-standard/:documentIsoStandardId/:departmentId/:documentTypeId",
      name: "listDocumentPublicFilteredIsoStandard",
      component: () =>
        import(
          "./components/listDocument/listDocumentPublicFilteredIsoStandard"
        ),
      meta: {
        appName: "listDocument",
      },
    },
    {
      path: "table-public",
      name: "listDocumentPublicTable",
      component: () =>
        import("./components/listDocument/listDocumentPublicTable"),
      meta: {
        appName: "listDocumentPublicTable",
      },
    },
    {
      path: "report-table-public",
      name: "listReportDocumentPublicTable",
      component: () =>
        import("./components/listDocument/listReportDocumentPublicTable"),
      meta: {
        appName: "listReportDocumentPublicTable",
      },
    },
    {
      path: "report-table-public/export",
      name: "listReportDocumentPublicTableExport",
      component: () =>
        import("./components/listDocument/listReportDocumentPublicTableExport"),
    },
    {
      path: "table-public/export",
      name: "listDocumentPublicTableExport",
      component: () =>
        import("./components/listDocument/listDocumentPublicTableExport"),
    },
    {
      path: "list-editor",
      name: "listDocumentForEditor",
      component: () =>
        import("./components/listDocument/listDocumentForEditor"),
      meta: {
        appName: "listDocumentForEditor",
      },
    },
    {
      path: "detail/:idDocument",
      name: "detailDocument",
      component: () => import("./detailDocument"),
    },

    {
      path: "update/:idDocument",
      name: "updateDocument",
      component: () => import("./updateDocument"),
    },
    {
      path: "add",
      name: "addDocument",
      component: () => import("./addDocument"),
    },
    // ban hành : release
    {
      path: "list-document-release",
      name: "listReleaseDocumentCreatedByMe",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.created-by-me"
        ),
      meta: {
        appName: "listReleaseDocumentCreatedByMe",
      },
    },
    {
      path: "list-document-release-need-editing",
      name: "listReleaseDocumentNeedEditing",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.need-editing"
        ),
      meta: {
        appName: "listReleaseDocumentNeedEditing",
      },
    },
    {
      path: "list-document-release-submiting",
      name: "listReleaseDocumentSubmitting",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.submitting"
        ),
      meta: {
        appName: "listReleaseDocumentSubmitting",
      },
    },
    {
      path: "list-document-release-approved",
      name: "listReleaseDocumentApproved",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.approved"
        ),
      meta: {
        appName: "listReleaseDocumentApproved",
      },
    },
    {
      path: "list-document-release-rejected",
      name: "listReleaseDocumentRejected",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.rejected"
        ),
      meta: {
        appName: "listReleaseDocumentRejected",
      },
    },
    {
      path: "list-need-document-release",
      name: "listReleaseDocument",
      component: () =>
        import("./components/listDocument/listDocumentPublicIsoRelease"),
      meta: {
        appName: "listReleaseDocument",
      },
    },
    {
      path: "list-document-release/wait-approve",
      name: "listReleaseDocumentWaitApprove",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.wait-approve"
        ),
      meta: {
        appName: "listReleaseDocumentWaitApprove",
      },
    },
    {
      path: "list-document-release/has-approved",
      name: "listReleaseDocumentHasApproved",
      component: () =>
        import(
          "./components/list-document-release/list-document-release.has-approved"
        ),
      meta: {
        appName: "listReleaseDocumentHasApproved",
      },
    },
    {
      path: "detail-document-release/:idDocument",
      name: "detailReleaseDocument",
      component: () =>
        import("./components/detail-release/detail-release.page"),
    },
    {
      path: "update-document-release/:idDocument",
      name: "updateReleaseDocument",
      component: () =>
        import("./components/detail-release/detail-release.update"),
    },
    {
      path: "edit-document-ref/:idDocument",
      name: "editDocumentRef",
      component: () => import("./components/detail-release/edit-document-ref"),
    },
    // Config
    {
      path: "config/document-type",
      name: "config/document-type",
      component: () =>
        import("./components/config/document-type/listDocumentType"),
      meta: {
        appName: "config/document-type",
      },
    },
    {
      path: "config/document-agency-issued",
      name: "config/document-agency-issued",
      component: () =>
        import(
          "./components/config/document-agency-issued/document-agency-issued.list"
        ),
      meta: {
        appName: "config/document-agency-issued",
      },
    },
    {
      path: "config/document-iso-standard",
      name: "config/document-iso-standard",
      component: () =>
        import(
          "./components/config/document-iso-standard/document-iso-standard.list"
        ),
      meta: {
        appName: "config/document-iso-standard",
      },
    },
  ],
};
